import styled from "styled-components";
import { RATypography, RAImage } from "@/components/customs";
import { Row, Col } from "antd";
import { IconAircraftOutline } from "@/assets/images";

export function AirportLegInfo({ from_airport = {}, to_airport }) {
	return (
		<Row gutter={[20, 20]}>
			<Col xs={9}>
				<WrapperAirport>
					<RATypography variant="sub-heading3" color="#222222" align="center">
						{from_airport?.icao_code ?? "_"}
					</RATypography>
					<RATypography variant="sub-heading5" color="#A8A8A8" align="center" maxLines={2}>
						{from_airport?.name ?? "_"}
					</RATypography>
				</WrapperAirport>
			</Col>
			<Col xs={6}>
				<WrapperAirport style={{ height: "100%" }}>
					<LineAircraft>
						<IconAbsolute>
							<RAImage url={IconAircraftOutline} width="22px" height="22px" objectFit="contain" />
						</IconAbsolute>
					</LineAircraft>
				</WrapperAirport>
			</Col>
			<Col xs={9}>
				<WrapperAirport>
					<RATypography variant="sub-heading3" color="#222222" align="center">
						{to_airport?.icao_code ?? "_"}
					</RATypography>
					<RATypography variant="sub-heading5" color="#A8A8A8" align="center" maxLines={2}>
						{to_airport?.name ?? "_"}
					</RATypography>
				</WrapperAirport>
			</Col>
		</Row>
	);
}

const WrapperAirport = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 6px;
`;
const LineAircraft = styled.div`
	position: relative;
	width: 100%;
	border-top: 1px dashed rgba(14, 14, 18, 0.204791);
`;
const IconAbsolute = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;
